<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        :class="[
            'mx-auto',
            'text-center',
            'bg-' + (alertType === 'success' ? 'green-lighten-4' : 'red-lighten-4')
        ]"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4" elevation="2">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Proveedores</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn color="primary" :loading="isImporting" :disabled="isImporting" @click="importProviders">
                        <template #loader>
                            <v-progress-circular indeterminate size="20" color="white" />
                        </template>
                        Importar de Odoo
                    </v-btn>
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :items="providers"
                :headers="headers"
                class="elevation-1"
                no-data-text="No hay proveedores disponibles"
            ></v-data-table>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

import { useRouter } from 'vue-router'

const router = useRouter()

const isImporting = ref(false)

const alertMessage = ref('')
const alertType = ref('success') // 'success' o 'error'
const showAlert = ref(false)

const showAlertMessage = (message, type = 'success') => {
    alertMessage.value = message
    alertType.value = type
    showAlert.value = true
    setTimeout(() => {
        showAlert.value = false
    }, 4000)
}

const providers = ref([])
const headers = [
    { title: 'ID Odoo', value: 'odoo_id' , sortable: true},
    { title: 'Nom', value: 'name' , sortable: true}
]

const fetchProviders = async () => {
    try {
        const {data} = await axios.get('/api/admin/providers', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        providers.value = data
    }
    catch (e) {
        console.error('Error loading providers:', e)
        if (e.response?.status === 401) {
            localStorage.removeItem('token')
            await router.push('/')
        }
        showAlertMessage('Error cargando los proveedores.', 'error')
    }
}

const importProviders = async () => {
    isImporting.value = true
    showAlertMessage('Importando datos de Odoo...', 'success')
    try {
        await axios.post('/api/admin/providers/import', {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        await fetchProviders()
        showAlertMessage('Importación completada correctamente.', 'success')
    } catch (e) {
        console.error('Error importando proveedores:', e)
        showAlertMessage('Error importando los proveedores.', 'error')
    } finally {
        isImporting.value = false
    }
}

onMounted(fetchProviders)
</script>
